<app-common-announcement [announcementMessage]="announcementData"></app-common-announcement>

<nav class="navbar navbar-expand-lg" id="consumer-header">
    <div class="container-fluid consumer-profile-header pl-20 pr-20 align-items-center">
        <div class="d-flex align-items-center">
            <img alt="" class="side_logo_text_booking d-show-350" src="assets/images/favicon/CCLogo.png" />
            <img alt="" class="fav_logo d-none-350" src="assets/images/favicon/fav_icon_new.png" />
        </div>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#publicNavbar"
            aria-controls="publicNavbar" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse justify-content-end" id="publicNavbar">
            <ul class="navbar-nav mb-2 mb-lg-0 d-flex align-items-center">
                <li class="nav-item">
                    <a href="https://www.classcover.com.au/teachers/" class=" fs-14 nav-link">Learn more</a>
                </li>
                <li class="nav-item">
                    <a href="https://www.classcover.com.au/hire-teachers-through-classcover-jobs/"
                        class=" fs-14  nav-link">post a job</a>
                </li>
                <li class="nav-item">
                    <a href="https://booking-test.classcover.com.au/login" class=" fs-14  nav-link mr-20">Login</a>
                </li>
                <li class="nav-item">
                    <a style="color: #3a0ca3 !important;" href="https://booking-test.classcover.com.au/signup"
                        class="cc_p_btn_outline fs-14 clr-cc-vilot">Sign
                        up</a>
                </li>
            </ul>
        </div>
    </div>
</nav>